import { environment } from '@env/environment';
var AppConfig = /** @class */ (function () {
    function AppConfig() {
        this.apiUrl = environment.apiUrl;
        this.apiAuthUrl = environment.apiAuthUrl;
        this.apiS3PaymentUrl = environment.s3PaymentUrl;
        this.apiS3DocumentUrl = environment.s3DocumentUrl;
        // public apiUrl = 'https://testroamingse.new-backend.trackwalkins.com/v1/roamingse/';
        // public apiAuthUrl= 'https://testroamingse.new-backend.trackwalkins.com/auth/roamingse/';
    }
    return AppConfig;
}());
export { AppConfig };
;



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/app.config.ts.pre-build-optimizer.js